import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import useContextMenu from '@Hooks/useContextMenu';
import { duplicateChoiceResult, deleteChoiceResult } from '@Services/Editor';

import { ReactComponent as MoreIconSVG } from '@Assets/Svgs/ic_more.svg';
import TX from '@Components/Common/Text';
import { ContextMenu, Item } from '@Components/Common/ContextMenu';

const ResultShowMoreButton = ({ isDisabledDeleteItem, processId, choiceId, resultId }) => {
  const dispatch = useDispatch();
  const { isContextMenuVisible, handleShowContextMenuClick } = useContextMenu();

  const handleDuplicateChoiceResultClick = useCallback(() => {
    dispatch(duplicateChoiceResult({ processId, choiceId, resultId }));
  }, [dispatch]);

  const handleDeleteChoiceResultClick = useCallback(() => {
    dispatch(deleteChoiceResult({ processId, choiceId, resultId }));
  }, [dispatch]);
  return (
    <MoreButton onClick={event => handleShowContextMenuClick(event)}>
      <MoreIcon />

      {isContextMenuVisible && (
        <ContextMenu position={{ right: 5, top: 44 }}>
          <Item onClick={handleDuplicateChoiceResultClick}>
            <ContextMenuItemText>분기 복제</ContextMenuItemText>
          </Item>
          <Item disabled={isDisabledDeleteItem} onClick={handleDeleteChoiceResultClick}>
            <ContextMenuItemText disabled>분기 삭제</ContextMenuItemText>
          </Item>
        </ContextMenu>
      )}
    </MoreButton>
  );
};

ResultShowMoreButton.propTypes = {
  isDisabledDeleteItem: PropTypes.bool.isRequired,
  processId: PropTypes.number.isRequired,
  choiceId: PropTypes.number.isRequired,
  resultId: PropTypes.number.isRequired,
};

const MoreButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;

  border: none;
  background: none;

  cursor: pointer;
`;

const MoreIcon = styled(MoreIconSVG)`
  width: 16px;
  height: 16px;
`;

const ContextMenuItemText = styled(TX.FootnoteM)`
  color: ${({ theme, disabled }) => (disabled ? theme.colors.danger : theme.colors.red)};
`;

export default ResultShowMoreButton;
